<section class="db-ecommerce-menu-search-wrapper">
  <div class="db-ecommerce-menu-sidebar-items-wrapper">
    <div class="sidebar-menu-type-item-container" *ngIf="searchResult.length; else emptyBlock">
      <ng-container *ngFor="let item of searchResult let index = index">
        <div class="menu-type-category"
             *ngIf="!searchResult[index-1] || item.object_type !== searchResult[index-1].object_type"> {{types[item.object_type]}}</div>
        <div class="sidebar-menu-type-item" (click)="addNewMenuItem.emit(item)">
        <span class="sidebar-menu-type-item-title">
          {{item.title}}
        </span>

          <div class="add-menu-item-container">
            <i class="db-icon db-icon-ds-add"></i>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-template #emptyBlock>
      <div class="no-result-block">
        {{'text_noResultsFound' | dbText}}
      </div>
    </ng-template>
  </div>
</section>
